var Konva = require('./_CoreInternals').Konva;
Konva._injectGlobal(Konva);
exports['default'] = Konva;
Konva.default = Konva;
module.exports = exports['default'];



//////////////////
// WEBPACK FOOTER
// ./node_modules/konva/lib/Core.js
// module id = 547
// module chunks = 0